import { CLIENT_APP_ID, LOGIN_URL } from "@/constants/index";

const paths = {
    login: `${LOGIN_URL}?clientAppId=${CLIENT_APP_ID}&returnUrl=${window.location.origin}`,
    adminList: '/admins',
    adminCreate: '/admins/create',
    adminDetail: '/admins/:id',
    appManagementList: '/app-management',
    appManagementCreate: '/app-management/create',
    appManagementDetail: '/app-management/:id',
    smsList: '/sms-transactions',
    smsConfig: '/sms-config',
    profile: '/profile',
    notFound: '/not-found',
    superAppList: '/super-apps',
    superAppCreate: '/super-apps/create',
    superAppDetail: '/super-apps/:id',
}

export default paths;